import { RasterCodingHelpModalComponent } from '../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/raster-coding-help-modal.component';
import { VectorTaggingHelpModalComponent } from '../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/vector-tagging-help-modal.component';
import { ImageAnnotationOutput } from '../../team-apis/otterdam/outputs/image-annotation-output';
import { OutputHelper } from './output-helper';

export class ImageOutputHelper extends OutputHelper<ImageAnnotationOutput> {
  override getHelpModalType(output: ImageAnnotationOutput) {
    if (output.meta.layer_type === 'raster_coding') {
      return RasterCodingHelpModalComponent;
    }
    return VectorTaggingHelpModalComponent;
  }
}
